import {genderList, raceList} from "../../../../Component/Common/Constants/Lists/DropdownListOptions";
import {
    WorkforceProfileOccupationalLevelTargets
} from "../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileOccupationalLevelTargets";
import {IGoalAndTargetRow} from "../../../Common/WorkforceProfile/GoalsAndTargetsCommon";

interface DeviationCellObject extends WorkforceProfileOccupationalLevelTargets.TargetYearAddtionalInfomation {
    showDeviation: boolean;
}

export function MapHeadcountPercentagePairs(pairs: WorkforceProfileOccupationalLevelTargets.HeadcountPercentagePair[] | null, raceGenderPairKeys: string[]): Record<string, number> {
    let result;
    if (!pairs || pairs.length === 0) {
        result = raceGenderPairKeys.reduce((acc, category) => {
            acc[`${category}Headcount`] = 0;
            acc[`${category}Percentage`] = 0;
            return acc;
        }, {} as Record<string, number>);
    } else {
        result = pairs.reduce((acc, {race, gender, headcount, percentage}) => {
            const category = `${raceList[race - 1].value} ${genderList[gender - 1].value}`;
            acc[`${category}Headcount`] = headcount;
            acc[`${category}Percentage`] = percentage;
            return acc;
        }, {} as Record<string, number>);
    }

    return result;
}

export function CalculateGap(
    actualPairs: Record<string, number>,
    targetPairs: Record<string, number>,
    raceGenderPairKeys: string[],
    usePercentageToCalculate: boolean = false
): Record<string, string> {

    return raceGenderPairKeys.reduce((acc, category) => {
        const actualHeadcount = actualPairs[`${category}Headcount`] || 0;
        const targetHeadcount = targetPairs[`${category}Headcount`] || 0;

        const headcountGap = actualHeadcount - targetHeadcount;
        let percentageGap: number | string;

        if (usePercentageToCalculate) {
            const actualHeadcountPercentage = actualPairs[`${category}Percentage`] || 0;
            const targetHeadcountPercentage = targetPairs[`${category}Percentage`] || 0;
            percentageGap = actualHeadcountPercentage - targetHeadcountPercentage;
        } else {
            percentageGap = targetHeadcount > 0
            ? (headcountGap / targetHeadcount) * 100
            : (actualHeadcount > 0 ? "N/A": 0);
        }

        acc[`${category}Headcount`] = headcountGap.toString();
        acc[`${category}Percentage`] = percentageGap.toString();
        return acc;
    }, {} as Record<string, string>);
}

export function MapDeviationData(pairs: WorkforceProfileOccupationalLevelTargets.TargetYearAddtionalInfomation[] | null, varianceData: Record<string, string>): Record<string, DeviationCellObject> {
    let result: Record<string, DeviationCellObject>;
    if (!pairs || pairs.length === 0) {
        result = {};
        raceList.forEach(r => {
            genderList.forEach(g => {
                const category = `${r.value} ${g.value}`;
                result[`${category}Headcount`] = {
                    category: category,
                    headcount: 0,
                    percentage: 0,
                    race: r.id as number,
                    gender: g.id as number,
                    showDeviation: false
                };
                result[`${category}Percentage`] = {
                    category: category,
                    headcount: 0,
                    percentage: 0,
                    race: r.id as number,
                    gender: g.id as number,
                    showDeviation: false
                };
            });
        });
    } else {
        result = pairs.reduce((acc, pair) => {
            const category = `${raceList[pair.race - 1].value} ${genderList[pair.gender - 1].value}`;
            const showDeviation = varianceData[`${category}Headcount`] != "0";
            acc[`${category}Headcount`] = {...pair, showDeviation: showDeviation}
            acc[`${category}Percentage`] = {...pair, showDeviation: showDeviation}
            return acc;
        }, {} as Record<string, DeviationCellObject>);
    }
    return result;

}

export function MapDrilldownData(pairs: WorkforceProfileOccupationalLevelTargets.HeadcountPercentagePair[] | null)
    : Record<string, WorkforceProfileOccupationalLevelTargets.HeadcountPercentagePair> {
    let result: Record<string, WorkforceProfileOccupationalLevelTargets.HeadcountPercentagePair>;
    if (!pairs || pairs.length === 0) {
        result = {};
        raceList.forEach(r => {
            genderList.forEach(g => {
                const category = `${r.value} ${g.value}`;
                result[`${category}Headcount`] = {
                    category: category,
                    headcount: 0,
                    percentage: 0,
                    race: r.id as number,
                    gender: g.id as number
                };
                result[`${category}Percentage`] = {
                    category: category,
                    headcount: 0,
                    percentage: 0,
                    race: r.id as number,
                    gender: g.id as number
                };
            });
        });
    } else {
        result = pairs.reduce((acc, pair) => {
            const category = `${raceList[pair.race - 1].value} ${genderList[pair.gender - 1].value}`;
            acc[`${category}Headcount`] = {...pair}
            acc[`${category}Percentage`] = {...pair}
            return acc;
        }, {} as Record<string, WorkforceProfileOccupationalLevelTargets.HeadcountPercentagePair>);
    }
    return result;

}

export function MapUpdatedRowToGoalsAndTargetRow(updatedRow: any): IGoalAndTargetRow {
    return {
        id: updatedRow.TargetRow,
        label: updatedRow.Description,
        scorecardId: updatedRow.scorecardId,
        isDisabled: updatedRow.isDisabled,
        occupationalLevel: updatedRow.occupationalLevel,
        maleAfricanValue: updatedRow["African MaleHeadcount"],
        maleColouredValue: updatedRow["Coloured MaleHeadcount"],
        maleIndianValue: updatedRow["Indian MaleHeadcount"],
        maleWhiteValue: updatedRow["White MaleHeadcount"],
        femaleAfricanValue: updatedRow["African FemaleHeadcount"],
        femaleColouredValue: updatedRow["Coloured FemaleHeadcount"],
        femaleIndianValue: updatedRow["Indian FemaleHeadcount"],
        femaleWhiteValue: updatedRow["White FemaleHeadcount"],
        maleForeignNationalValue: updatedRow["Non South African MaleHeadcount"],
        femaleForeignNationalValue: updatedRow["Non South African FemaleHeadcount"]
    }
}